export enum PublicVerifierDetailsPreviewParams {
  previewUuid = "previewUuid",
}
